import React from 'react';
import { sanitizeString } from '../../utils/sanitization';

const SecureInput = ({ value, onChange, type = 'text', maxLength = 100, ...props }) => {
    const handleChange = (e) => {
        const sanitized = sanitizeString(e.target.value, maxLength);
        onChange(sanitized);
    };

    return (
        <input
            {...props}
            type={type}
            value={value}
            onChange={handleChange}
            maxLength={maxLength}
            autoComplete={type === 'password' ? 'current-password' : 'off'}
        />
    );
};

export default SecureInput;